import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49bf08e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "monitoring-days-table"
}
const _hoisted_2 = { class: "monitoring-days-table__day-work" }
const _hoisted_3 = { class: "monitoring-days-table__day-month-work" }
const _hoisted_4 = {
  key: 1,
  class: "monitoring-days-table__no-find-users"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitoring-days-table__no-find-users-title" }, "Данные не найдены", -1))
const _hoisted_6 = { key: 1 }

import {
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPagination,
  TirPmScrollbar,
} from 'tir-components';
import { TirPmTableTh, TirPmTable } from 'tir-pm-table';
import { Bars3BottomLeftIcon, MagnifyingGlassIcon } from 'tir-style-system/icons/outline';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { MonitoringsAdapterService } from '../../adapter-service';
import PerformerTaskDaysRequestModel from '../../models/PerformerTaskDaysRequestModel';
import { useRouter } from 'vue-router';
import PageRequestModel from '../../models/PageRequestModel';
import PerformerTaskDaysResponseItemsModel from '../../models/PerformerTaskDaysResponseItemsModel';
import DailySummariesModel from '../../models/DailySummariesModel';
import { PaginationRequestModel, PaginationResponseModel } from '@/models';
import {
  GetProjectTasksRequestModel,
  MonitoringHeaderFilterModel,
  TaskColumnModel,
  TaskFilterModel,
  TaskModel,
} from '../../models';
import PageResponseModel from '../../models/PageResponseModel';
import GetEmployeesWithAccessToProjectItemModel from '../../models/GetEmployeesWithAccessToProjectItemModel';
import { TaskViewElementEnum } from '../../enums';
import UserModel from '../../models/UserModel';
import GetTasksListMonitoringDaysRequesModel from '../../models/GetTasksListMonitoringDaysRequesModel';
import MonitoringDaysTableInfo from './monitoring-days-table-info.vue';
import MonitoringDaysDrawerTasks from './monitoring-days-drawer-tasks.vue';
import { debounce } from 'tir-pm-debounce';
import { MonitoringsSkeleton } from '../../monitorings-skeleton';

const DEFAULT_PAGE_STEP = 50;

/**Список задач */

export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-days-table',
  props: {
  /**Фильтр мониторинга */
  filter: { type: Object as PropType<MonitoringHeaderFilterModel> },
  /**Начальная дата */
  selectDateStart: { type: Date },
  /**Конечная дата */
  selectDateEnd: { type: Date },
  /**Выбранный исполнитель */
  selectPerformer: { type: Object as PropType<GetEmployeesWithAccessToProjectItemModel> },
},
  emits: ["getTotalWorkTime", "openTasksListDrawer"],
  setup(__props, { emit }) {

const props = __props;





/**Адаптер */
const adapter = new MonitoringsAdapterService();

/**Роутер */
const router = useRouter();

/**Страница */
const pageResponse = ref<PageResponseModel>();

/**Текущая страница */
const currentPage = ref<number>();

/**Дефолтное кол-во элементов на странице */
const tasks = ref([]);

/**Ссылка на скролл */
const $scrollbar = ref<InstanceType<typeof TirPmScrollbar>>();

/**Ссылка на таблицу */
const $table = ref<HTMLElement>();

/**Данные юзера выбранной задачи  */
const selectUserData = ref({} as UserModel);

/**Данные сводок выбраной задачи  */
const selectDailySummaries = ref({} as DailySummariesModel);

/**Колонки */
const columns: TaskColumnModel[] = [
  new TaskColumnModel({
    Type: TaskViewElementEnum.Namespace,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Queue,
    Name: 'Очередь',
    Width: '9.375rem',
    MinWidth: '9.375rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Number,
    Name: '№',
    Width: '5rem',
    MinWidth: '5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Name,
    Name: 'Название',
    Width: '24.3125rem',
    MinWidth: '24.3125rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Status,
    Name: 'Статус',
    Width: '5.688rem',
    MinWidth: '5.1875rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Priority,
    Name: 'Приоритет',
    Width: '3.625rem',
    MinWidth: '3.625rem',
    Align: 'right',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.EstimateTime,
    Name: 't (оценка)',
    Width: '4.875rem',
    MinWidth: '4.875rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.WorkTime,
    Name: 't (затрачено)',
    Width: '4.875rem',
    MinWidth: '4.875rem',
    Align: 'center',
  }),
];

/**Видимость tir-pm-drawer */
const visibleDrawer = ref(false);
/**Загрузка */
const loading = ref(false);

/**ID проекта */
const projectId = Number(router.currentRoute.value.params.projectId);

/**Кол-во элементов на странице */
const pageStep = ref(DEFAULT_PAGE_STEP);

/**Колонки таблицы */
const columnTableSetting = ref(['minmax(14.438rem, 14.438rem)', 'minmax(6.713rem, 6.713rem)']);

/**Данные юзера */
const dataUsers = ref<PerformerTaskDaysResponseItemsModel[]>([]);

/**Данные по дням */
const dailySummaries = ref<DailySummariesModel[]>([]);

/**Итоговое время юзера */
const timeSpentUser = ref<number>();

/**Кол-во страниц */
const pagesCount = computed(
  () => pageResponse.value && Math.ceil(pageResponse.value.Count / pageResponse.value.Size),
);

const getColumnWidths = computed(() => {
  return [
    ...columnTableSetting.value,
    ...dailySummaries.value.map(() => 'minmax(6.213rem, 6.213rem)'),
  ];
});

/** Получение списка сотрудников и их затраченное время на задачи по дням */
const getPerformerTaskDaysReport = async (page: PageRequestModel) => {
  loading.value = true;
  const response = await adapter.getPerformerTaskDaysReportAsync(
    new PerformerTaskDaysRequestModel({
      Search: props.filter.Search,
      ProjectId: props.filter.AllMyProjectsChecked ? null : projectId,
      DateStart: props.selectDateStart,
      DateEnd: props.selectDateEnd,
      Page: page,
      PerformerIds: props.selectPerformer.UserId ? [props.selectPerformer.UserId] : [],
    }),
  );
  if (response.IsSuccess) {
    dataUsers.value = response.Value.Items;
    pageResponse.value = response.Value.Page;
    currentPage.value = response.Value.Page.Current;
    dailySummaries.value = response.Value.Items.map((item) => item.DailySummaries)[0] || [];

    emit('getTotalWorkTime', response.Value.TotalWorkTime);
    setTimeout(() => $scrollbar.value?.$scroll.scrollTo($table.value.offsetWidth, 0));
  } else {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: response.ErrorMessage ?? 'Ошибка получения списка задач',
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
      }),
    );
  }
  loading.value = false;
};

/**Поиск юзеров */
const seatchUsers = debounce(
  () =>
    getPerformerTaskDaysReport(
      new PageRequestModel({
        Skip: 0,
        Take: pageStep.value,
      }),
    ),
  300,
);
/** Получить список задач */
const getTasks = async (request: GetTasksListMonitoringDaysRequesModel) => {
  const response = await adapter.getTasksByProjectId(
    new GetProjectTasksRequestModel({
      ProjectId: props.filter.AllMyProjectsChecked ? null : projectId,
      Filter: new TaskFilterModel({
        Performers: request.SelectedPerformerId,
      }),
      DateStart: request.SelectDateStart || props.selectDateStart,
      DateEnd: request.SelectDateEnd || props.selectDateEnd,
      IsFilterTimerByPerformerIds: true,
      Page: request.Page,
    }),
  );
  if (response.IsSuccess) {
    tasks.value = response?.Items || [];
  } else {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: response.ErrorMessage ?? 'Ошибка получения списка задач',
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
      }),
    );
  }

  return response.IsSuccess;
};

watch(
  () => [props.selectDateStart, props.selectDateEnd],
  () => {
    getPerformerTaskDaysReport(
      new PageRequestModel({
        Skip: 0,
        Take: pageStep.value,
      }),
    );
  },
);
/**Отслеживание изменения строки поиска */
watch(
  () => props.filter.Search,
  () => seatchUsers(),
);
/**Отслеживание изменения состояния чекбокса Все мои проекты */
watch(
  () => props.filter.AllMyProjectsChecked,
  () => {
    getPerformerTaskDaysReport(
      new PageRequestModel({
        Skip: 0,
        Take: pageStep.value,
      }),
    );
  },
);

/**Изменить кол-во элементов на странице */
const changePageStep = async (value: number) => {
  pageStep.value = value;
  await getPerformerTaskDaysReport(
    new PageRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
};

/**Обновить текущую страницу */
const changeCurrentPage = async (value: number) => {
  if (!pageResponse.value || currentPage.value === value) return;

  await getPerformerTaskDaysReport(
    new PageRequestModel({
      Skip: pageResponse.value.Size * (value - 1),
      Take: pageStep.value,
    }),
  );
};

/**Закрыть дравер */
const closeDrawer = () => {
  visibleDrawer.value = false;
};

const openDrawer = () => {
  visibleDrawer.value = true;
};

/**Обновить видимость дравера */
const onUpdateVisibleDrawer = (value: boolean) => {
  visibleDrawer.value = value;
};

/**Открыть шторку с задачами */
const openTasksListDrawer = async (
  user: PerformerTaskDaysResponseItemsModel,
  daily: DailySummariesModel,
) => {
  const startDate = new Date(daily.Date);
  startDate.setUTCHours(0, 0, 0, 0);
  startDate.setUTCDate(startDate.getUTCDate());

  const endDate = new Date(startDate);
  endDate.setUTCDate(startDate.getUTCDate() + 1);
  endDate.setUTCHours(0, 0, 0, 0);

  await getTasks(
    new GetTasksListMonitoringDaysRequesModel({
      Page: new PaginationRequestModel({
        Skip: 0,
        Take: pageStep.value,
      }),
      SelectedPerformerId: [user.UsersData.Id],
      SelectDateStart: startDate,
      SelectDateEnd: endDate.toISOString().split('Z')[0],
    }),
  );

  selectUserData.value = user.UsersData;

  const timeSpent = user.DailySummaries.find(
    (d) =>
      new Date(d.Date).toISOString().split('T')[0] ===
      new Date(daily.Date).toISOString().split('T')[0],
  )?.TotalTimeSpent;

  timeSpentUser.value = timeSpent;
  selectDailySummaries.value = daily;

  onUpdateVisibleDrawer(true);
};

/**Отфильтрованные колонки */
const filteredDailySummaries = computed(() => {
  const uniqueDates = new Set();

  return dailySummaries.value.filter((item) => {
    const formattedDate = new Date(item.Date).toISOString().split('T')[0];

    if (uniqueDates.has(formattedDate)) {
      return false;
    }

    uniqueDates.add(formattedDate);
    return true;
  });
});

/**Получить день недели */
const getDayWeek = (date: Date) => {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate());

  const dayOfWeek = newDate.getDay();
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

  return {
    day: newDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toUpperCase(),
    isWeekend,
  };
};

const computedDayData = computed(() => {
  const sortedData = filteredDailySummaries.value
    .map((daily) => {
      const dayData = getDayWeek(daily.Date);
      return {
        ...daily,
        isWeekend: dayData.isWeekend,
        day: dayData.day,
      };
    })
    .sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime());

  return sortedData;
});

onMounted(async () => {
  await getPerformerTaskDaysReport(
    new PageRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
});

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (dataUsers.value.length)
          ? (_openBlock(), _createBlock(_unref(TirPmScrollbar), {
              key: 0,
              ref_key: "$scrollbar",
              ref: $scrollbar,
              class: "monitoring-days-table__scroll",
              "show-on-hover": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  ref_key: "$table",
                  ref: $table
                }, [
                  _createVNode(_unref(TirPmTable), {
                    columns: getColumnWidths.value,
                    isBordered: false
                  }, {
                    tableHead: _withCtx(() => [
                      _createVNode(_unref(TirPmTableTh), {
                        class: "monitoring-days-table__main-column",
                        isLeftBorder: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Сотрудник "),
                          _createVNode(_unref(Bars3BottomLeftIcon), { class: "monitoring-days-table__icon" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TirPmTableTh), {
                        class: "monitoring-days-table__main-column general-hours-column",
                        isLeftBorder: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Общ. часы ")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedDayData.value, (daily) => {
                        return (_openBlock(), _createBlock(_unref(TirPmTableTh), { class: "monitoring-days-table__days-work-column" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["monitoring-days-table__day-week-work", { 'weekend-day': daily.isWeekend }])
                            }, _toDisplayString(daily.day), 3),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(new Date(daily.Date).getDate()), 1),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(new Date(daily.Date).toLocaleString('ru-RU', { month: 'short' }).replace('.', '')), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 256))
                    ]),
                    tableBody: _withCtx(() => [
                      _createVNode(MonitoringDaysTableInfo, {
                        filter: __props.filter,
                        dataUsers: dataUsers.value,
                        columnWidths: getColumnWidths.value,
                        dailySummaries: dailySummaries.value,
                        onEventOpenTasksListDrawer: openTasksListDrawer
                      }, null, 8, ["filter", "dataUsers", "columnWidths", "dailySummaries"]),
                      _createVNode(MonitoringDaysDrawerTasks, {
                        visibleDrawer: visibleDrawer.value,
                        selectUserData: selectUserData.value,
                        selectDailySummaries: selectDailySummaries.value,
                        tasks: tasks.value,
                        columns: columns,
                        timeSpentUser: timeSpentUser.value,
                        onEventCloseDrawer: closeDrawer,
                        onEventOpenDrawer: openDrawer,
                        onEventonUpdateVisibleDrawer: onUpdateVisibleDrawer
                      }, null, 8, ["visibleDrawer", "selectUserData", "selectDailySummaries", "tasks", "timeSpentUser"])
                    ]),
                    _: 1
                  }, 8, ["columns"])
                ], 512)
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true),
        (!dataUsers.value.length && !loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(TirPmIconView), {
                size: 80,
                isBordered: false
              }, {
                mainSlot: _withCtx(() => [
                  _createVNode(_unref(MagnifyingGlassIcon))
                ]),
                _: 1
              }),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (pageResponse.value?.Current && pagesCount.value)
          ? (_openBlock(), _createBlock(_unref(TirPmPagination), {
              key: 2,
              class: "monitoring-days-table__paginator",
              showMoreElements: "",
              "model-value": pageResponse.value?.Current,
              "range-size": 3,
              pages: pagesCount.value,
              options: [10, 20, 30, 40, 50, 100],
              "count-elements": pageStep.value,
              "onUpdate:countElements": changePageStep,
              "onUpdate:modelValue": changeCurrentPage
            }, null, 8, ["model-value", "pages", "count-elements"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_unref(MonitoringsSkeleton))
      ]))
}
}

})